module.exports = __webpack_public_path__ + "img/writeqs.ef8e8389.jpg";